import { combineReducers } from 'redux';
import { AuthReducer } from './AuthReducer';
import { LoaderReducer } from './LoaderReducer';
import { ClientReducer } from './ClientReducer';
import { DocumentReducer } from './DocumentReducer';
import { DiagnosisReducer } from './DiagnosisReducer';
import { AppointmentReducer } from './AppointmentReducer';
import { TreatmentPlanSignReducer } from './TreatmentPlanSignReducer';
import { ApplyClientSignatureReducer } from './Apply_Client_Signature'
import { MessagesReducer } from './MessagesReducer'


const appReducer = combineReducers({
  AuthReducer,
  LoaderReducer,
  ClientReducer,
  DocumentReducer,
  DiagnosisReducer,
  AppointmentReducer,
  TreatmentPlanSignReducer,
  ApplyClientSignatureReducer,
  MessagesReducer
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
